import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { first } from 'rxjs/operators';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { StructureNodeVO } from 'src/app/shared/models/CordinationCatalog';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { Constants } from 'src/app/shared/vo/Constants';

@Component({
  selector: 'app-coordination-catalog',
  templateUrl: './coordination-catalog.component.html',
  styleUrls: ['./coordination-catalog.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class CoordinationCatalogComponent implements OnInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  storeId: string;

  /** LABELS */
  lbl_go_Back: string = "back_";
  lbl_church_name: string = "church_name_";
  lbl_workshop: string = "workshop_";
  lbl_schedule: string = "schedule_";
  lbl_participants: string = "participants_";
  lbl_new_record: string = "new_record_";
  lbl_name: string = "name_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_email: string = "email_";
  lbl_gender: string = "gender_";
  lbl_edit: string = "edit_";
  lbl_delete: string = "delete_";
  lbl_search: string = "search_";
  lbl_particp15s: string = "10a15a_particip_";
  lbl_participants_12: string = "participants_";
  lbl_participants_1st: string = "participants_2nd_sesion_";
  lbl_future_guide: string = "future_guide_";
  lbl_partic_partner: string = "partic_partners_";
  lbl_no_sent: string = "no_sent_";
  lbl_age: string = "age_";
  lbl_school_prep_guides: string = "school_prep_guides_";
  lbl_comments: string = "comments_";
  lbl_date: string = "date_";
  lbl_save: string = "save_";
  lbl_guide_id: string = "guide_id_";
  lbl_certificate: string = "certificate_";
  lbl_change_Status_Guide_or_Comment: string = "change_Status_Guide_or_Comment";
  lbl_coordination: string = "coordination_";
  lbl_guideId: string = "guideId_";
  lbl_status: string = "status_";
  lbl_leaving_reason: string = "leaving_reason_";
  lbl_select: string = "select_";
  lbl_send: string = "send_";
  lbl_guide: string = "guide_";
  lbl_confirm: string = "confirm_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_updated_data: string = "updated_data_";
  lbl_delete_record: string = "delete_record_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";
  lbl_total: string = "total_";
  lbl_record: string = "record_";
  lbl_zonal_coordinations: string = "zonal_coordinations_";
  lbl_new: string = "new_";
  lbl_type: string = "type_";
  lbl_coordinator: string = "coordinator_";
  lbl_secretary: string = "secretary_";
  lbl_treasurer: string = "treasurer_";
  lbl_material_man: string = "material_man_"
  lbl_Guide: string = "Guide_";
  lbl_youngs: string = "youngs_";
  lbl_school_prep_guides_charge: string = "school_prep_guides_charge_";
  lbl_loading: string = "loading_";
  lbl_coordinations: string = "coordinations_";
  lbl_coordination_catalog: string = "coordination_catalog_";



  lstCols: { field: string; header: any; }[];

  /** COMPONENT */
  coordinationCatalogList: StructureNodeVO[];
  coordinationCatalog?: StructureNodeVO;
  selectedCoordinationCatalog: StructureNodeVO[] = [];
  

  /** COMPONENT EXPORT */
  tableName: string;
  blocked: boolean = true;



  /**
   * This is a constructor function that initializes various services and variables used in the
   * component.
   * @param {MessageService} messageService - This parameter is of type `MessageService` and is used for
   * displaying messages to the user. It is likely used to show success or error messages after certain
   * actions are performed.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making HTTP requests to the API.
   * @param {Router} router - The `router` parameter is used for routing within the application. It
   * allows you to navigate to different components or pages based on user actions or events.
   * @param {ActivatedRoute} route - The `route` parameter is used to access the current route
   * information, such as the URL parameters and query parameters. It is provided by the Angular
   * `ActivatedRoute` class.
   * @param {AuthenticationService} authenticationService - This parameter is an instance of the
   * AuthenticationService class, which is used for handling user authentication and authorization. It
   * provides methods for logging in, logging out, and checking the current user's authentication status.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private filesService: TovpilFilesService) {

    this.tableName = this.getTableName();

    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
        this.storeId = params.storeId;
      });


  }


  itemsNavigation?: MenuItem[] = [];
  homeNavigation: MenuItem;


  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    if (this.token && this.device && this.device === Constants.APP_USA) {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else {

      this.currentUser = this.authenticationService.currentUserValue;
      this.getSecurity();
      this.homeNavigation = { icon: 'pi pi-home', routerLink: '/catalogs/cordinationCatalog' };
    }
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if necessary.
   */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.token != null ? this.token : this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.loadMainData();

        });
    } else {
      this.loadMainData();

    }
  }



  /**
   * The function "loadCoordinationCatalogs" loads coordination catalogs from an API service and populates
   * various lists based on the received data.
   */
  loadCoordinationCatalogs() {
    if (this?.itemsNavigation?.length == 0 || !this?.itemsNavigation) {
      this.itemsNavigation.push({ label: " " + this?.security?.selYear + " - " + this?.security?.selPeriod, id: this?.security?.storeId });
    }
    this.lstCordinationCatalog();
  }

  /**
   * The function creates a navigation catalog with coordination details and navigates to the
   * coordination catalog detail page.
   */
  createCoordinationCatalog() {
    try {
      let navigationExtras: NavigationExtras = {
        state: JSON.parse(JSON.stringify({
          security: this.security,
          selectedCordination: this.selectedCoordinationCatalog
        }))
      };

      this.router.navigate(['/materials/cordinationCatalogDtl'], navigationExtras);
    } catch (error) {
      console.error("An error occurred while navigating:", error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error de navegación',
        detail: 'Hubo un problema al navegar. Por favor, inténtelo nuevamente.',
        life: 5000
      });
    }
  }


  /**
   * The function `deleteSelectedCoordinationCatalog()` confirms with the user if they want to delete a
   * record, and if confirmed, it deletes the selected coordination catalog items from a list and
   * displays a success message.
   */
  deleteSelectedCoordinationCatalog() {
    try {
      this.confirmationService.confirm({
        message: '¿ ' + this.lbl_are_you_sure + ' ' + this.lbl_delete_record + ' ?',
        header: this.lbl_confirm,
        icon: 'pi pi-exclamation-triangle',
        accept: () => {

          try {
            this.coordinationCatalogList = this.coordinationCatalogList.filter(val => !this.selectedCoordinationCatalog.includes(val));
            this.selectedCoordinationCatalog = null;
            this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Catálogo(s) de coordinación eliminado correctamente', life: 3000 });
          } catch (deleteError) {
            console.error("An error occurred while deleting coordination catalog:", deleteError);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Hubo un problema al eliminar el catálogo de coordinación', life: 5000 });
          }
        }
      });
    } catch (confirmationError) {
      console.error("An error occurred while confirming deletion:", confirmationError);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Hubo un problema al confirmar la eliminación', life: 5000 });
    }
  }

 

  selectionCoordinationCatalog(coordinationCatalog: StructureNodeVO) {
    if (coordinationCatalog.levelId != 'L' && coordinationCatalog?.storeId != null) {
      this.itemsNavigation.push({ label: " " + coordinationCatalog?.coordName, id: coordinationCatalog?.storeId });
      this.lstCordinationCatalog();
    } else if (coordinationCatalog.levelId != 'L' && coordinationCatalog?.storeId == null) {
      console.error("An error occurred while redirect state to JSON:");
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Hubo un problema al procesar los datos del catálogo de coordinación', life: 5000 });
    }
  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    if (this.itemsNavigation.length > 1) {
      this.itemsNavigation.pop();
    } else {
      window.close();
    }
    this.lstCordinationCatalog();
  }


  /**
   * The `getTranslatedLabels` function retrieves translations for a list of labels and assigns them to
   * the corresponding properties in the current object.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_church_name, this.lbl_schedule, this.lbl_participants, this.lbl_new_record, this.lbl_name, this.lbl_cell_phone, this.lbl_email, this.lbl_gender, this.lbl_edit, this.lbl_delete, this.lbl_search, this.lbl_particp15s, this.lbl_participants_12, this.lbl_participants_1st, this.lbl_future_guide, this.lbl_partic_partner, this.lbl_no_sent, this.lbl_age, this.lbl_workshop, this.lbl_school_prep_guides, this.lbl_comments, this.lbl_date, this.lbl_save, this.lbl_guide_id, this.lbl_certificate, this.lbl_change_Status_Guide_or_Comment, this.lbl_coordination, this.lbl_guideId, this.lbl_status, this.lbl_leaving_reason, this.lbl_select, this.lbl_send, this.lbl_guide, this.lbl_confirm, this.lbl_are_you_sure, this.lbl_updated_data, this.lbl_delete_record, this.lbl_showing, this.lbl_of, this.lbl_records, this.lbl_total, this.lbl_record, this.lbl_zonal_coordinations, this.lbl_new, this.lbl_type, this.lbl_coordinator, this.lbl_secretary, this.lbl_treasurer, this.lbl_material_man, this.lbl_Guide, this.lbl_youngs, this.lbl_school_prep_guides_charge, this.lbl_loading, this.lbl_coordinations, this.lbl_coordination_catalog]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_church_name = map.get(this.lbl_church_name);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_particp15s = map.get(this.lbl_particp15s);
        this.lbl_participants_12 = map.get(this.lbl_participants_12);
        this.lbl_participants_1st = map.get(this.lbl_participants_1st);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_partic_partner = map.get(this.lbl_partic_partner);
        this.lbl_no_sent = map.get(this.lbl_no_sent);
        this.lbl_age = map.get(this.lbl_age);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_school_prep_guides = map.get(this.lbl_school_prep_guides);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_date = map.get(this.lbl_date);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_change_Status_Guide_or_Comment = map.get(this.lbl_change_Status_Guide_or_Comment);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_leaving_reason = map.get(this.lbl_leaving_reason);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_send = map.get(this.lbl_send);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_record = map.get(this.lbl_record);
        this.lbl_zonal_coordinations = map.get(this.lbl_zonal_coordinations);
        this.lbl_new = map.get(this.lbl_new);
        this.lbl_type = map.get(this.lbl_type);
        this.lbl_coordinator = map.get(this.lbl_coordinator);
        this.lbl_secretary = map.get(this.lbl_secretary);
        this.lbl_treasurer = map.get(this.lbl_treasurer);
        this.lbl_material_man = map.get(this.lbl_material_man);
        this.lbl_Guide = map.get(this.lbl_Guide);
        this.lbl_youngs = map.get(this.lbl_youngs);
        this.lbl_school_prep_guides_charge = map.get(this.lbl_school_prep_guides_charge);
        this.lbl_loading = map.get(this.lbl_loading);
        this.lbl_coordinations = map.get(this.lbl_coordinations);
        this.lbl_coordination_catalog = map.get(this.lbl_coordination_catalog);
      });
  }


  /**
   * The `exportExcel` function exports data from `coordinationCatalogList` to an Excel file.
   */
  exportExcel() {
    try {
      if (this.coordinationCatalogList === null) {
        this.messageService.add({
          severity: 'error',
          summary: 'No existe información para procesar',
          life: 3000
        });
      } else if (this.coordinationCatalogList.length < 1) {
        this.messageService.add({
          severity: 'error',
          summary: 'La lista está vacía',
          life: 3000
        });
      } else {
        const filteredJSON = this.coordinationCatalogList.map((item) => ({
          "TIPO": item ? (item?.levelId || 'S/N') : 'S/N',
          "ID_ZONA": item ? (item?.supStoreId || 'S/N') : 'S/N',
          "NOMBRE": item ? (item?.coordName || 'S/N') : 'S/N',
          "COORDINADOR": item ? (item?.coord?.guideName || 'S/N') : 'S/N',
          "SECRETARIO": item ? (item?.secre?.guideName || 'S/N') : 'S/N',
          "TESORERO": item ? (item?.treas?.guideName || 'S/N') : 'S/N',
          "ENCARGADO_MATERIALES": item ? (item?.mater?.guideName || 'S/N') : 'S/N',
          "GUIA_JOVENES": item ? (item?.young?.guideName || 'S/N') : 'S/N',
          "ENCARGADO_ESCUELAS": item ? (item?.sfg?.guideName || 'S/N') : 'S/N',
        }));
        this.filesService.tovpilExportXLSX(filteredJSON, 'listcordinationCatalog_');
      }
    } catch (error) {
      console.error("An error occurred while exporting to Excel:", error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error de exportación',
        detail: 'Hubo un problema al exportar a Excel. Por favor, inténtelo nuevamente.',
        life: 5000
      });
    }
  }


  /**
   * The exportPdf function exports data from the coordinationCatalogList array to a PDF file.
   */
  exportPdf() {
    try {
      if (this.coordinationCatalogList === null) {
        this.messageService.add({
          severity: 'error',
          summary: 'No existe información para procesar',
          life: 3000
        });
      } else if (this.coordinationCatalogList.length < 1) {
        this.messageService.add({
          severity: 'error',
          summary: 'La lista está vacía',
          life: 3000
        });
      } else {
        const filteredJSON = this.coordinationCatalogList.map((item) => ({
          "TIPO": item ? (item?.levelId || 'S/N') : 'S/N',
          "ID_ZONA": item ? (item?.supStoreId || 'S/N') : 'S/N',
          "NOMBRE": item ? (item?.coordName || 'S/N') : 'S/N',
          "COORDINADOR": item ? (item?.coord?.guideName || 'S/N') : 'S/N',
          "SECRETARIO": item ? (item?.secre?.guideName || 'S/N') : 'S/N',
          "TESORERO": item ? (item?.treas?.guideName || 'S/N') : 'S/N',
          "ENCARGADO_MATERIALES": item ? (item?.mater?.guideName || 'S/N') : 'S/N',
          "GUIA_JOVENES": item ? (item?.young?.guideName || 'S/N') : 'S/N',
          "ENCARGADO_ESCUELAS": item ? (item?.sfg?.guideName || 'S/N') : 'S/N',
        }));

        const keysArray = filteredJSON.map((item) => Object.keys(item));
        const valuesArray = filteredJSON.map((item) => Object.values(item));

        this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listcordinationCatalog_');
      }
    } catch (error) {
      console.error("An error occurred while exporting to PDF:", error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error de exportación',
        detail: 'Hubo un problema al exportar a PDF. Por favor, inténtelo nuevamente.',
        life: 5000
      });
    }
  }


  /**
   * The function generates a table name based on the current date and returns it as a string.
   * @returns the table name as a string, enclosed in double quotes.
   */
  getTableName() {
    try {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}${month}${day}`;

      const filename = 'listcordinationCatalog_' + `${formattedDate}`;

      return `"${filename}"`;
    } catch (error) {
      console.error("An error occurred while generating table name:", error);
      return "error";
    }
  }

  get breadcrumbModel() {
    return this.itemsNavigation.map(item => ({ label: item.label }));
  }

  lstCordinationCatalog() {
    this.blocked = true;
    const storeId = this.itemsNavigation.length === 0 ? this.security.storeId : this.itemsNavigation[this.itemsNavigation.length - 1].id;
    const langauge = this.security.language;
    const filter = "FIRST_LEVEL_ONLY";

    this.apiService.lstCordinationCatalog({ storeId, langauge, filter })
      .then(data => {
        this.coordinationCatalogList = data;
        this.handleSuccess();
      })
      .catch(error => {
        console.error("An error occurred while fetching coordination catalog data:", error);
        this.handleError();
      })
      .finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });
  }

  private handleSuccess() {

  }

  private handleError() {
    this.goBack();
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.',
      life: 5000
    });
  }
  private loadMainData() {
    this.getTranslatedLabels();
    this.loadCoordinationCatalogs();
  }

}
